import { startReactDsfr } from '@codegouvfr/react-dsfr/spa';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Link } from 'react-router-dom';
import { z } from 'zod';
import { fr } from 'zod/locales';
import { App } from './App';
import { store } from './store';
import '@common/dsfr-ui';
import './index.css';

z.config(fr());
startReactDsfr({ defaultColorScheme: 'light', Link: Link as never });

// pushToServerOnRuntimeError('Inscription', store);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
